import { render, staticRenderFns } from "./ContentPagination2.vue?vue&type=template&id=57098a78&"
import script from "./ContentPagination2.vue?vue&type=script&lang=js&"
export * from "./ContentPagination2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports